import { useIntl } from 'react-intl'
import { applicationApi } from '@/api/applicationApi'
import {
  FilterSelectAsync,
  FilterSelectAsyncProps
} from '@/components/ui-shared/Tables/FilterSelect/FilterSelectAsync'
import { appQueryKeys } from '@/queries/applicationQueries'
import { Application } from '@/types/app'
import { PaginatedResponse } from '@/types/pagination'
import { MAX_ITEMS_WITHOUT_PAGINATION } from '@/utils/pagination'

const params = {
  limit: MAX_ITEMS_WITHOUT_PAGINATION,
  ordering: 'name'
}

type AppFilterProps = Pick<
  FilterSelectAsyncProps<Application, PaginatedResponse<Application[]>>,
  'value' | 'onChange'
>

export const AppFilter = ({ value, onChange }: AppFilterProps) => {
  const intl = useIntl()

  return (
    <FilterSelectAsync<Application, PaginatedResponse<Application[]>>
      width={220}
      value={value}
      queryFn={() => applicationApi.getApplicationList(params)}
      queryKey={appQueryKeys.list(params)}
      selectFn={(data) => data.results}
      getOptionValue={(application) => application.id}
      getOptionLabel={(application) => application.name}
      placeholder={intl.formatMessage({
        id: 'deployments.list.filter.application.placeholder'
      })}
      onChange={onChange}
    />
  )
}
